import { CopyValue } from '@components'
import { IBusiness } from '@query'
import React from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { EInvoicingShareCard } from './EInvoicingShareCard'

interface Props {
  business: IBusiness
}

export const EInvoicingShareModalContent: React.FC<Props> = ({ business }) => {
  const { t } = useTranslation()

  return (
    <Stack>
      <Details>
        <Field>
          <Label>{t('settings.einvoicing.einvoicingAddress')}</Label>
          <CopyValue value={business.einvoicing_address} />
        </Field>
        <Field>
          <Label>{t('settings.einvoicing.einvoicingOperator')}</Label>
          <CopyValue value={business.einvoicing_operator} />
        </Field>
      </Details>
      <EInvoicingShareCard business={business} layout="stacked" />
    </Stack>
  )
}

const Stack = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.md}rem;
`

const Details = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(12rem, 1fr));
  gap: ${({ theme }) => theme.spacing.sm}rem;
`

const Field = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.xs}rem;
  min-width: 0;
`

const Label = styled.span`
  font-size: ${({ theme }) => theme.fontSize.sm}rem;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.menuBg};
`
